<div class="cookie-consent" [class.shown]="showDialog && externalPage == false">
    <p>This website is using cookies to deliver its services and to analyse traffic. <a href="/legal/privacy-policy" target="_blank">More info</a></p>
    <a class="cookie-button" href="javascript:void(0);" (click)="acceptClick()">That's fine</a>
</div>
